import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './NumberSelect.module.css'

export default class NumberSelect extends Component {
  static propTypes = {
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    value: PropTypes.number
  }

  render () {
    return (
      <div onClick={this.props.onClick} className={styles.numberselect}>
        <button disabled={this.props.disabled} className={styles['numberselect-button']} />
        <div data-value={this.props.disabled ? 0 : this.props.value} className={styles['numberselect-indicator']} />
      </div>
    )
  }
}
